import React from "react";
import "./PageSubDescription.css";

class PageSubDescription extends React.Component {
  render() {
    const { text } = this.props;
    if (text) {
      return <h2 className="page-sub-description">{text}</h2>;
    }
    return null;
  }
}

export default PageSubDescription;



// WEBPACK FOOTER //
// ./src/components/PageSubDescription/PageSubDescription.jsx